export const FETCH_TERMSCONDS_REQUEST = "FETCH_TERMSCONDS_REQUEST";
export const FETCH_TERMSCONDS_SUCCESS = "FETCH_TERMSCONDS_SUCCESS";
export const FETCH_TERMSCONDS_FAILURE = "FETCH_TERMSCONDS_FAILURE";